import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Downtown KC needed",
      "Ideal for Lee's Summit professionals with international business",
      "Perfect for families with upcoming European or Caribbean vacations",
      "Great for last-minute trips booked from MCI",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Lee's Summit post offices",
      "Good for planned international trips from MCI",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Lee's Summit USPS",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Kansas City — ~25 mi, 30–45 min drive",
      "NPIC appointment required before traveling to Kansas City",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function LeeSummitProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Lee's Summit"
      introText="Lee's Summit residents — business professionals flying out of MCI for international meetings, families planning summer vacations to Europe and the Caribbean, and Jackson County travelers with upcoming international trips — have several options for getting a passport fast. Here is how they compare, and why most Lee's Summit residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to Downtown Kansas City."
      options={options}
      emergencyDescription="Lee's Summit does not have its own regional passport agency. The closest is Kansas City — about 25 miles northwest, typically 30–45 minutes but often longer with I-470 and downtown KC traffic. For a local professional with a last-minute business trip or a family with an upcoming international flight from MCI, that round trip is a half-day commitment with no guarantee of service."
      disclaimerText="*Processing speed depends on eligibility and documentation. Lee's Summit does not have a regional passport agency — the closest is Kansas City. Not all applicants qualify for Regional Agency Processing."
    />
  );
}